<template>
  <v-content>
    <header-bar v-if="isEmailVerified" />

<!--    <unverified-email-banner />-->

    <router-view />

    <menu-drawer v-if="isEmailVerified" />
  </v-content>
</template>
<script>
import UnverifiedEmailBanner from '@/components/UnverifiedEmailBanner.vue'
import MenuDrawer from '@/components/MenuDrawer.vue'
import HeaderBar from "../HeaderBar/HeaderBar"
import { mapGetters } from 'vuex'

export default {
  components: {
    HeaderBar,
    UnverifiedEmailBanner,
    MenuDrawer
  },
  computed: {
    ...mapGetters([ 'isEmailVerified' ])
  }
}
</script>
